"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function FreeWithCardComponent(props) {
  var flexTitle = props.flexTitle,
    desc = props.desc,
    flexSmallTitle = props.flexSmallTitle,
    mergeComponentStatus = props.mergeComponentStatus,
    _a = props.modalList,
    modalList = _a === void 0 ? [] : _a,
    onCallback = props.onCallback,
    _b = props.configuration,
    configuration = _b === void 0 ? [] : _b;
  // const { list, description } = configuration || {};
  var actionsList = configuration ? configuration.slice(-1)[0] || {} : {};
  var href = actionsList.href,
    _c = actionsList.txt,
    txt = _c === void 0 ? '' : _c,
    extendProps = actionsList.extendProps;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-free-with-card'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-free-with-card__children'
  }, (flexTitle || desc || flexSmallTitle) && ( /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle,
    modalList: modalList
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-free-with-card__container'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'flex-free-with-card__container__ul'
  }, configuration.map(function (item, index) {
    var _a = item || {},
      mainNum = _a.mainNum,
      description = _a.description;
    if (!mainNum) return null;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: (0, _classnames["default"])('', {
        'flex-free-with-card__container__ul__after': configuration.length - 1 === index
      })
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'blue-title'
    }, mainNum), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'article-content'
    }, description)));
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: 'flex-free-with-card__container__transition'
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: 'flex-free-with-card__container__actions'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/89728b5e9c8a8f0466df6b8fd0af286616304953753056935.png'
  }), /*#__PURE__*/_react["default"].createElement("button", __assign({
    className: 'actions--btn',
    onClick: function onClick() {
      if (onCallback) onCallback(configuration);
    }
  }, extendProps || {}), !onCallback && href ? /*#__PURE__*/_react["default"].createElement("a", {
    href: href
  }, txt) : /*#__PURE__*/_react["default"].createElement("span", null, txt)))))));
}
var FreeWithCard = function FreeWithCard(props) {
  var paddingTopNum = props.paddingTopNum,
    paddingBottomNum = props.paddingBottomNum,
    flexTitle = props.flexTitle,
    style = props.style,
    isFooterPart = props.isFooterPart,
    isCombination = props.isCombination;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(FreeWithCardComponent, __assign({}, props)));
};
FreeWithCard.displayName = 'TCIFreeWithCard';
var _default = exports["default"] = FreeWithCard;